import { render, staticRenderFns } from "./touchFullSceen.vue?vue&type=template&id=7c2ae89c&scoped=true&"
import script from "./touchFullSceen.vue?vue&type=script&lang=js&"
export * from "./touchFullSceen.vue?vue&type=script&lang=js&"
import style0 from "./touchFullSceen.vue?vue&type=style&index=0&id=7c2ae89c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2ae89c",
  null
  
)

export default component.exports